import {createStyles, makeStyles, Theme} from "@material-ui/core";
import {grey} from "@material-ui/core/colors";

export const TablePaginationActionStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexShrink: 0,
            cursor:'pointer',
            marginLeft: theme.spacing(2.5),
            color: grey[400],
        },
        input: {
            color: grey[400]
        },
        actions: {
            color: grey[400]
        }
    }),
);